import APIUrl from "../../APIUrl";
import axios from "axios";
import Roles from "../../enums/Roles";

export const GET_RENTALS = "GET_RENTALS";
export const GET_RENTALS_ADMIN = "GET_RENTALS_ADMIN";
export const GET_RENTALS_SALES = "GET_RENTALS_SALES";
export const VALIDATE_RENTAL_SUCCESS = "VALIDATE_RENTAL_SUCCESS";
export const VALIDATE_RENTAL_ERROR = "VALIDATE_RENTAL_ERROR";
export const UPDATE_RENTAL_STATUS_SUCCESS = "UPDATE_RENTAL_STATUS_SUCCESS";
export const UPDATE_RENTAL_STATUS_ERROR = "UPDATE_RENTAL_STATUS_ERROR";
export const CREATE_DM_RENTALS_SUCCESS = "CREATE_DM_RENTALS_SUCCESS";
export const CREATE_DM_RENTALS_ERROR = "CREATE_DM_RENTALS_ERROR";

export function getRentalsAction(rentals) {
  return { type: GET_RENTALS, rentals: rentals };
}

export function getRentalsAdminAction(rentals) {
  return { type: GET_RENTALS_ADMIN, rentals: rentals };
}

export function getRentalsSalesAction(rentals) {
  return { type: GET_RENTALS_SALES, rentals: rentals };
}

export function validateRentalSuccessAction(rental) {
  return { type: VALIDATE_RENTAL_SUCCESS, rental: rental };
}

export function validateRentalErrorAction(error) {
  return { type: VALIDATE_RENTAL_ERROR, error: error };
}

export function updateRentalStatusSuccessAction(rental) {
  return { type: UPDATE_RENTAL_STATUS_SUCCESS, rental: rental };
}

export function updateRentalStatusErrorAction(error) {
  return { type: UPDATE_RENTAL_STATUS_ERROR, error: error };
}

export function createDmRentalsSuccessAction(rentals) {
  return { type: CREATE_DM_RENTALS_SUCCESS, rentals: rentals };
}

export function createDmRentalsErrorAction(error) {
  return { type: CREATE_DM_RENTALS_ERROR, error: error };
}

export const getRentals = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getRentals)
      .then(function (response) {
        dispatch(getRentalsAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const getRentalsAdmin = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getRentalsAdmin)
      .then(function (response) {
        dispatch(getRentalsAdminAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const getRentalsSales = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getRentalsSales)
      .then(function (response) {
        dispatch(getRentalsSalesAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const validateRental = function (
  productId,
  startDate,
  endDate,
  validationComment,
  quantity,
  allocation,
  selectedResidents,
  locationsData,
) {
  return function (dispatch) {
    const requestData = {
      product_id: productId,
      start_date: startDate,
      end_date: endDate,
    };

    // Only include validation_comment if it's provided
    if (validationComment && validationComment.trim() !== "") {
      requestData.validation_comment = validationComment.trim();
    }

    // Include quantity if provided (default is 1 on backend)
    if (quantity) {
      requestData.quantity = quantity;
    }

    // Include allocation if provided
    if (allocation) {
      requestData.allocation = allocation;
    }

    // Include selected residents if provided
    if (selectedResidents && selectedResidents.length > 0) {
      requestData.selected_residents = selectedResidents;
    }

    // Include locations data if provided
    if (locationsData) {
      requestData.locations_data = locationsData;
    }

    return axios
      .post(APIUrl.validateRental, requestData)
      .then(function (response) {
        dispatch(validateRentalSuccessAction(response.data.rental));
        // Refresh rentals after validation
        dispatch(getRentals());
        return response.data;
      })
      .catch(function (err) {
        dispatch(
          validateRentalErrorAction(err.response?.data?.error || err.message),
        );
        throw err;
      });
  };
};

export const updateRentalStatus = function (rentalId, newStatus) {
  return function (dispatch, getState) {
    const user = getState().user;

    return axios
      .put(`${APIUrl.updateRentalStatus}/${rentalId}/status`, {
        status: newStatus,
      })
      .then(function (response) {
        dispatch(updateRentalStatusSuccessAction(response.data.rental));
        // Refresh rentals after status update based on user role
        if (user.role === Roles.ADMIN) {
          dispatch(getRentalsAdmin());
        } else if (user.role === Roles.SALES_REP) {
          dispatch(getRentalsSales());
        } else {
          dispatch(getRentals());
        }
        return response.data;
      })
      .catch(function (err) {
        dispatch(
          updateRentalStatusErrorAction(
            err.response?.data?.error || err.message,
          ),
        );
        throw err;
      });
  };
};

export const createDmRentals = function (dmRentalsData) {
  return function (dispatch, getState) {
    const user = getState().user;

    return axios
      .post(`${APIUrl.rootUrl}/rental/create-dm-rentals`, {
        dmRentalsData: dmRentalsData,
      })
      .then(function (response) {
        dispatch(createDmRentalsSuccessAction(response.data.rentals));
        // Refresh rentals after creation based on user role
        if (user.role === Roles.ADMIN) {
          dispatch(getRentalsAdmin());
        } else if (user.role === Roles.SALES_REP) {
          dispatch(getRentalsSales());
        } else {
          dispatch(getRentals());
        }
        return response.data;
      })
      .catch(function (err) {
        dispatch(
          createDmRentalsErrorAction(err.response?.data?.error || err.message),
        );
        throw err;
      });
  };
};

export const searchEquipmentsByRef = function (searchTerm) {
  return function (dispatch) {
    if (!searchTerm || searchTerm.trim() === "") {
      return Promise.resolve([]);
    }

    return axios
      .get(`${APIUrl.rootUrl}/equipment/search-by-ref`, {
        params: {
          term: searchTerm.trim(),
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        console.error("Error searching equipments:", err);
        return [];
      });
  };
};

export const updateRentalResident = function (rentalId, residentData) {
  return function (dispatch, getState) {
    const user = getState().user;

    return axios
      .put(`${APIUrl.rootUrl}/rental/${rentalId}/resident`, residentData)
      .then(function (response) {
        // Refresh rentals after update based on user role
        if (user.role === Roles.ADMIN) {
          dispatch(getRentalsAdmin());
        } else if (user.role === Roles.SALES_REP) {
          dispatch(getRentalsSales());
        } else {
          dispatch(getRentals());
        }
        return response.data;
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const updateRentalInternalRef = function (rentalId, refInterne) {
  return function (dispatch, getState) {
    const user = getState().user;

    return axios
      .put(`${APIUrl.rootUrl}/rental/${rentalId}/internal-ref`, {
        ref_interne: refInterne,
      })
      .then(function (response) {
        // Refresh rentals after update based on user role
        if (user.role === Roles.ADMIN) {
          dispatch(getRentalsAdmin());
        } else if (user.role === Roles.SALES_REP) {
          dispatch(getRentalsSales());
        } else {
          dispatch(getRentals());
        }
        return response.data;
      })
      .catch(function (err) {
        throw err;
      });
  };
};
